import { render, staticRenderFns } from "./CustomWidth.vue?vue&type=template&id=24d41b24"
import script from "./CustomWidth.vue?vue&type=script&lang=js"
export * from "./CustomWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports